const Navbar = () => {
    return (
        <div className="navbar bg-base-300 mb-8">
            <div className="navbar-start">
            </div>
            <div className="navbar-center">
                <a href="" className="btn btn-ghost normal-case text-3xl">LectureGPT</a>
            </div>
            <div className="navbar-end">
            </div>
        </div>
    )
}

export default Navbar;